import translate from "@insite/client-framework/Translate";
import Link from "@insite/mobius/Link";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { connect } from "react-redux";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
 
type Props = ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: ApplicationState) => ({
    isAuthenticated: getSession(state).isAuthenticated,
});

export interface SignInForPricingStyles {
    linkButtonWrap?: InjectableCss;
}

export const productBrandStyles: SignInForPricingStyles = {
    linkButtonWrap: {
        css: css`
            margin-top: 16px;
            color: #254351;
            border-color: #254351;
            font-size: 14px;
            text-align: center;
            text-transform: none;
            border: 3px solid #254351;
            background-color: #fff;
            padding: 10px;
            height: auto;
            font-family: "Franklin Gothic Demi" !important;
            text-decoration: none !important;
            font-weight: 700;
            box-shadow: none!important;
            display: flex;
            align-items: center;
            justify-content: center;
            :hover {
                background-color: #254351;
                color: #f2f2f2 !important;
                border: 3px solid #254351;
                transition: .3s;
                box-shadow: none !important;
                ${TypographyStyle}{
                    color: #f2f2f2 !important;
                }
            }
            ${TypographyStyle}{
                font-size: 14px !important;
                height: auto !important;
                line-height: 14px;
                color: #254351 !important;
            }
        `,
    },
};

const styles = productBrandStyles;

const SignInForButton: FC<Props> = ({ isAuthenticated  }) => {
    return (
        <>
            {isAuthenticated?'':
                <Link {...styles.linkButtonWrap} href="/SignIn" data-test-selector="signinforpricing">
                    {translate("Sign In for pricing and availability")}
                </Link>
            }
        </>
    )
};
 
export default connect(mapStateToProps)(SignInForButton);